module.exports = __webpack_public_path__ + "fransa mutfak 14.jpg?8c01ba685127d3ea6fb11396349227ac";


//////////////////
// WEBPACK FOOTER
// ./src/HtmlFiles/img/fransa mutfak 14.jpg
// module id = 345
// module chunks = 0